import React, { Fragment, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import GoogleMapReact from "google-map-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  ButtonGroup,
  Container,
  Collapse,
} from "reactstrap";

const AnyReactComponent = ({ tooltip }) => {
  return (
    <div title={tooltip}>
      <div className="text-danger">
        <FontAwesomeIcon icon={faMapMarkerAlt} size="4x" />
      </div>
    </div>
  );
};

export default function PropertyDetail({ data }) {
  const [custom1, setCustom1] = useState(false);

  //console.log("data in property", data)
  let center = {
    lat: data?.situs_lat,
    lng: data?.situs_lon,
  };

  let zoom = 14;

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          classNames="TabsAnimation"
          appear={true}
          timeout={0}
          enter={false}
          exit={false}
        >
          <div>
            <Row>
              <Col md="12">
                <Row>
                  <Col md="12">
                    <Card className="main-card mb-2">
                      <CardBody>
                        <CardTitle>
                          <Row>
                            <Col xs="10">
                              <legend>GALLERY/MAP</legend>
                            </Col>
                            <Col xs="2">
                              <Button
                                className="m-0 p-0"
                                color="link"
                                onClick={() => setCustom1(!custom1)}
                              >
                                {custom1 === false ? "Expand" : "Collapse"}
                              </Button>
                            </Col>
                          </Row>
                        </CardTitle>

                        <Collapse
                          isOpen={custom1}
                          data-parent="#exampleAccordion"
                          id="exampleAccordion1"
                        >
                          <Row>
                            <Col md="12">
                              <Card className="main-card mb-3">
                                <CardBody>
                                  {custom1 && (
                                    <div
                                      style={{ height: "40vh", width: "100%" }}
                                    >
                                      <GoogleMapReact
                                        defaultCenter={center}
                                        defaultZoom={zoom}
                                      >
                                        <AnyReactComponent
                                          lat={center.lat}
                                          lng={center.lng}
                                          tooltip={
                                            data.situs_official_street_address
                                          }
                                        />
                                      </GoogleMapReact>
                                    </div>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </Collapse>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Card className="main-card mb-2">
                    <CardBody>
                      <Row className="g-1 mb-1">
                        <Col md="2">
                          <div className="card  widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.property_info?.rooms || "-"}
                            </div>
                            <div className="widget-subheading">Rooms </div>
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.floors || "-"}
                            </div>
                            <div className="widget-subheading">Floors</div>
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="card  widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.equity || "-"}
                            </div>
                            <div className="widget-subheading">Equyity</div>
                          </div>
                        </Col>

                        <Col md="2">
                          <div className="card  widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.property_info?.parking || "-"}
                            </div>
                            <div className="widget-subheading">Parking</div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.owner_property_count || "-"}{" "}
                            </div>
                            <div className="widget-subheading">
                              Owner Property Count
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card  widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.est_value || "-"}
                            </div>
                            <div className="widget-subheading">Est Value</div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card  widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.rental_estimate || "-"}
                            </div>
                            <div className="widget-subheading">Rent Est </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.last_sold_price || "-"}
                            </div>
                            <div className="widget-subheading">
                              Last Sold Price
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.last_sold_date || "-"}
                            </div>
                            <div className="widget-subheading">
                              Last Sold Date
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.owner_occupied || "-"}{" "}
                            </div>
                            <div className="widget-subheading">
                              Owner Occupied
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.vacant || "-"}{" "}
                            </div>
                            <div className="widget-subheading">Vacant</div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.property_info?.hoa || "-"}{" "}
                            </div>
                            <div className="widget-subheading">HOA</div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="card widget-chart p-0">
                            <div className="widget-numbers">
                              {data?.property_info?.private_pool || "-"}{" "}
                            </div>
                            <div className="widget-subheading">Pool</div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Row>
                <Row>
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>Property Characteristics</CardTitle>
                      <Row>
                        <Col className="mb-1" xs="6" md="4">
                          <h6 className="fw-bold m-0">Appliances</h6>
                          <p>{data?.property_info?.appliances || "-"} </p>
                          <h6 className="fw-bold m-0">Heating</h6>
                          <p>{data?.property_info?.heating || "-"} </p>
                          <h6 className="fw-bold m-0">Water</h6>
                          <p>{data?.property_info?.water_source || "-"} </p>
                          <h6 className="fw-bold m-0">Garage Spaces</h6>
                          <p>{data?.property_info?.garage_spaces || "-"} </p>
                          <h6 className="fw-bold m-0">Fire Places</h6>
                          <p>{data?.property_info?.garage_fireplaces || "-"}</p>
                          <h6 className="fw-bold m-0">Garage Type</h6>
                          <p>{data?.property_info?.garage_type || "-"}</p>
                        </Col>
                        <Col className="mb-1" xs="6" md="4">
                          <h6 className="fw-bold m-0">Cooling</h6>
                          <p>{data?.property_info?.cooling || "-"}</p>
                          <h6 className="fw-bold m-0">Flooring</h6>
                          <p>{data?.property_info?.flooring || "-"}</p>
                          <h6 className="fw-bold m-0">Exterior Features</h6>
                          <p>{data?.property_info?.exterior_features || "-"}</p>
                          <h6 className="fw-bold m-0">Exterior Material</h6>
                          <p>{data?.property_info?.exterior_material || "-"}</p>
                          <h6 className="fw-bold m-0">Fire Palces</h6>
                          <p>{data?.property_info?.garage_fireplaces || "-"}</p>
                          <h6 className="fw-bold m-0">Structure</h6>
                          <p>{data?.property_info?.structure_type || "-"}</p>
                        </Col>
                        <Col className="mb-1" xs="6" md="4">
                          <h6 className="fw-bold m-0">Roof</h6>
                          <p>{data?.property_info?.roof || "-"}</p>
                          <h6 className="fw-bold m-0">Laundry</h6>
                          <p>{data?.property_info?.laundry || "-"}</p>
                          <h6 className="fw-bold m-0">Utilities</h6>
                          <p>{data?.property_info?.utilities || "-"}</p>
                          <h6 className="fw-bold m-0">Interior</h6>
                          <p>{data?.property_info?.interior_features || "-"}</p>
                          <h6 className="fw-bold m-0">Pets</h6>
                          <p>{data?.property_info?.pets || "-"}</p>
                          <h6 className="fw-bold m-0">Parking</h6>
                          <p>{data?.property_info?.parking_features || "-"}</p>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Row>

                <Row>
                  <Col md="12">
                    <Card className="main-card mb-1">
                      <CardBody>
                        <CardTitle>Schools</CardTitle>
                        <Row className="g-0">
                          {data?.property_info?.schools?.map((school, k) => (
                            <Col md="12" className="mb-1" key={k}>
                              <Card
                                className="main-card"
                                style={{ backgroundColor: "#f4f6f7" }}
                              >
                                <CardBody>
                                  <CardTitle>{school.name}</CardTitle>
                                  <Row className="g-0">
                                    <Col xs="5">
                                      <b>Level:</b>{" "}
                                      {typeof school?.education_levels ===
                                      "string"
                                        ? school?.education_levels
                                        : school?.education_levels.map(
                                            (edu) => edu + ", "
                                          )}
                                    </Col>
                                    <Col xs="3">
                                      <b>Grades:</b> {school.grades}
                                    </Col>
                                    <Col xs="4">
                                      {typeof school?.ratings === "number" ? (
                                        <>
                                          <b>Rating: </b>{" "}
                                          {school?.ratings || " -"}
                                        </>
                                      ) : (
                                        <>
                                          <b>Rating: </b>{" "}
                                          {school?.ratings?.parent_rating !==
                                          null
                                            ? school?.ratings?.parent_rating
                                            : school?.ratings
                                                ?.great_schools_rating}
                                        </>
                                      )}
                                    </Col>

                                    <Col xs="5" className="mt-1">
                                      <b>Type:</b> {school.school_type || "-"}
                                    </Col>
                                    <Col xs="3" className="mt-1">
                                      <b>Size:</b> {school.size || "-"}
                                    </Col>
                                    <Col xs="4" className="mt-1">
                                      <b>Distance in Miles:</b>{" "}
                                      {school.distance_in_miles}
                                    </Col>
                                    <Col md="12" className="mt-1">
                                      <Row className="g-0">
                                        {school?.addresses?.map(
                                          (address, key) => (
                                            <Col md="12" key={key}>
                                              <b>ADDRESS:</b> {address.address1}
                                              , {address.city}, {address.state}{" "}
                                              {address.zip}
                                            </Col>
                                          )
                                        )}
                                      </Row>
                                    </Col>
                                    <Col md="12" className="mt-1">
                                      <Row className="g-0">
                                        {school?.phones?.map((ph, keyy) => (
                                          <Col xs="4" key={keyy}>
                                            <b>Phones:</b> {ph.phone}
                                          </Col>
                                        ))}
                                      </Row>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <Card className="main-card mb-1">
                      <CardBody>
                        <CardTitle>Price History</CardTitle>

                        {data?.property_info?.price_history?.map((v, k) => (
                          <Row key={k} className="g-1">
                            <Col xs="4" className="mb-1">
                              <b>({k + 1})</b> {v.event}
                            </Col>
                            <Col xs="4" className="mb-1">
                              <b>Price: </b> {v.price}
                            </Col>
                            <Col xs="4" className="mb-1">
                              <b>Sold Date: </b> {v.sold_date}
                            </Col>
                          </Row>
                        ))}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <Card className="main-card mb-1">
                      <CardBody>
                        <CardTitle>Tax History</CardTitle>

                        {data?.property_info?.tax_history?.map((v, k) => (
                          <Row key={k} className="g-1">
                            <Col xs="4" className="mb-1">
                              <b>Tax: </b> {v.tax}
                            </Col>
                            <Col xs="4" className="mb-1">
                              <b>Year: </b> {v.year}
                            </Col>
                            <Col xs="4" className="mb-1">
                              {typeof v?.assessment === "number" ? (
                                <>
                                  <b>Assessment: </b> {v?.assessment || " -"}
                                </>
                              ) : (
                                <>
                                  <b>Assessment: </b>{" "}
                                  {v?.assessment?.total || " -"}
                                </>
                              )}
                            </Col>
                          </Row>
                        ))}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
}
